export default "__VITE_ASSET__i9k_szvZ__"